import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, {
  IFilter,
  IHttpResponse,
  IUri,
  buildUrl,
} from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'events';

interface IGetGroupEventList extends Omit<IUri, 'resource'> {
  token?: string | null;
  filters: IFilter[];
}
interface IGetGroupEventListResponse extends IHttpResponse {
  body?: {
    _embedded?: {
      events?: IGroupEvent[] | undefined;
    };
    count?: number;
  };
}
export default async ({
  token,
  filters,
  pages,
}: IGetGroupEventList): Promise<IGetGroupEventListResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: filters,
    pages: pages,
    resource: RESOURCE,
  });
  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    token: token ? token : guestToken,
    skipTimestamp: true,
  });
};
